import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "connected-react-router";
import createRootReducer from "./reducers";
import { createBrowserHistory } from "history";
import { connectRouter } from "connected-react-router";
import catalogRootSaga from "containers/Catalog/sagas";
import productDetailsRootSaga from "containers/ProductDetails/sagas";
import { gtmMiddleware, gaMiddleware } from "./beacon";
import productViewHistoryMiddleware from "productViewHistory";

const sagaMiddleware = createSagaMiddleware();

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const history = createBrowserHistory();

const possibleTranslationPrefix = window.location.pathname
  .slice(1)
  .split("/")[0];

const translationPrefix = ["fr"].includes(possibleTranslationPrefix)
  ? `/${possibleTranslationPrefix}`
  : "";

const initialState = {
  app: { webFontsLoaded: false, wpFooterLoaded: false },
  catalog: {
    loading: true,
    routeRoot: `${translationPrefix}/products`,
    allDoorsRoute: `${translationPrefix}/products/doors`,
    interiorRoute: `${translationPrefix}/products/doors`,
    exteriorRoute: `${translationPrefix}/products/doors`,
    lastPath: null
  },
  productDetails: {
    loading: true,
    routeRoot: `${translationPrefix}/products/door`
  }
};

let middleWares = [
  productViewHistoryMiddleware,
  routerMiddleware(history),
  sagaMiddleware
];

// Add support for Google Analytics if `ga` is already defined from embedded GA snippet.
if (window.ga) {
  middleWares.push(gaMiddleware)
}

// Add support for Google Tag Manager if `dataLayer` is already defined from embedded GTM snippet.
if (window.dataLayer) {
  middleWares.push(gtmMiddleware)
}

const composeEnhancers = composeEnhancer(applyMiddleware(...middleWares));

export default createStore(
  connectRouter(history)(createRootReducer),
  initialState,
  composeEnhancers
);

sagaMiddleware.run(catalogRootSaga);
sagaMiddleware.run(productDetailsRootSaga);
